<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="print-fingljournal-main">
    <div class="fingljournal-filter">
      <div class="fingljournal-filters-tablebox">
        <div class="fingljournal-filters-summary">
          <span></span>
        </div>
        <ButtonFilter
          buttonText="Change Filter"
          filterPosition="right"
          :filterWidth="300"
          :isOpen.sync="journalFiltersIsOpen"
        >
          <div class="button-filter-content-container">
            <BoxContainer class="date-filter-container" title="Journal Date">
              <DateTimePicker
                placeholder="Start Date"
                :value.sync="journalStartDate"
                :showTime="false"
                :isRequired="true"
                :errorMessage.sync="journalStartDateErrorMessage"
              />
              <DateTimePicker
                placeholder="End Date"
                :value.sync="journalEndDate"
                :showTime="false"
                :isRequired="true"
                :errorMessage.sync="journalEndDateErrorMessage"
              />
            </BoxContainer>

            <div class="refresh-button-container">
              <button @click="filterRefreshClick">Refresh</button>
            </div>
          </div>
        </ButtonFilter>
      </div>
      <div class="fingljournal-tablebox-container">
        <TableBox
          title="Batch Listing"
          :tableData="journalListing"
          :selectedRow.sync="selectedJournal"
          :maxSelection="-1"
          :showSelectAll="true"
          :dataType="{'Sys Date':'date','FYear':'number','Total':'currency','No of Entry':'number','Date Update':'datetime','Date Created':'datetime'}"
          :hideColumns="['txnhdr','updind']"
        />
      </div>
      <!-- <BoxContainer class="txnDate-filter-container" title="Transaction Date">
        <div style="display: flex; justify-content: space-between">
          <DateTimePicker
            :showTime="false"
            placeholder="Start"
            :isDisabled="allTransaction"
            :value.sync="txnStartDate"
            :errorMessage.sync="txnStartDateErr"
          />
          <DateTimePicker
            :showTime="false"
            placeholder="To"
            :isDisabled="allTransaction"
            :value.sync="txnEndDate"
            :errorMessage.sync="txnEndDateErr"
          />
          <CheckBoxV2 title="All Transactions for the Financial Year" :isChecked.sync="allTransaction" />
        </div>
      </BoxContainer> -->
      <div class="fingljournal-document-type">
        <!-- <RadioButtonSet title="Document Type" :buttons="documentTypeList" labelKey="labelKey" :selected.sync="selectedDocumentType" :isRequired="true" :isHorizontal="true" /> -->
        <Filters
          title="Document Type"
          :tableData="documentTypeList"
          itemKey="Type"
          :selectedObject.sync="selectedDocumentType"
          :tableBoxHideColumns="['keyValue']"
        />
      </div>
      <CheckBoxV2 title="Exclude Cancel Records" :isChecked.sync="exclCancelRec" />
      <CheckBoxV2 title="Exclude Posting Records" :isChecked.sync="exclPostRec" />

      <RadioButtonSet
        ref="reportformat"
        title="Report Format"
        :buttons="reportFormatOptions"
        labelKey="label"
        :selected.sync="selectedReportFormat"
        :isHorizontal="true"
        :isRequired="true"
        style="margin-right: 5px"
      />
      <div style="display: flex; flex-direction: row; justify-content: flex-end; margin-top: 10px">
        <button @click="previewClick" :disabled="previewButtonDisabled">Preview Journal Listing</button>
      </div>
    </div>
    <div class="fingljournal-preview">
      <DesignerV3
        v-if="showDesignerV3"
        :reportFiles="designerV3ReportFiles"
        :reportData="designerV3ReportData"
        :sharedData="designerV3SharedData"
        :canToggleBackground="false"
        :canShare="false"
        :canClose="false"
        :downloadName="downloadFileName"
        ref="designerv3"
      />
      <div v-else class="user-instructions">
        <span>Click on <strong>Preview Journal Listing</strong> to get started</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      rptHeader: '',
      journalFiltersIsOpen: false,
      journalStartDate: new Date(new Date().setMonth(new Date().getMonth() - 3)),
      journalStartDateErrorMessage: '',
      journalEndDate: new Date(),
      journalEndDateErrorMessage: '',

      journalListing: [],
      selectedJournal: [],
      // allTransaction: false,
      // txnStartDate: new Date(),
      // txnStartDateErr: '',
      // txnEndDate: new Date(),
      // txnEndDateErr: '',
      documentTypeList: [
        {
          Type: 'Invoice',
          keyValue: '1',
        },
        {
          Type: 'Debit Note',
          keyValue: '2',
        },
        {
          Type: 'Credit Note',
          keyValue: '3',
        },
        {
          Type: 'Receipt',
          keyValue: '6',
        },
        {
          Type: 'Journal',
          keyValue: '0',
        },
        {
          Type: 'AP Inv',
          keyValue: '4',
        },
        {
          Type: 'AP CN',
          keyValue: '5',
        },
        {
          Type: 'Cheque',
          keyValue: '7',
        },
        {
          Type: 'Petty Cash',
          keyValue: '8',
        },
        {
          Type: 'Expenses',
          keyValue: '9',
        },
        {
          Type: 'Fixed Assets',
          keyValue: '10',
        },
        {
          Type: 'GST Gift Rule',
          keyValue: '11',
        },
        {
          Type: 'GST Bad Debts',
          keyValue: '12',
        },
      ],
      selectedDocumentType: [],
      exclCancelRec: true,
      exclPostRec: false,
      reportFormatOptions: [
        { label: 'Summary', key: 'SUMMARY' },
        { label: 'Details', key: 'DETAILS' },
      ],
      selectedReportFormat: null,
      previewButtonDisabled: false,

      //#region DesignerV3
      showDesignerV3: false,
      designerV3ReportFiles: [],
      designerV3ReportData: [],
      designerV3SharedData: [],
      // designerV3SharedBehaviour: {
      //   behaviour: 'uploadAndEmit'
      // },
      downloadFileName: '',
      //#endregion
    };
  },
  props: {},
  methods: {
    async filterRefreshClick() {
      let check = false;
      if (!this.journalStartDate) {
        check = true;
        this.journalStartDateErrorMessage = 'Enter Start Date';
      }
      if (!this.journalEndDate) {
        check = true;
        this.journalEndDateErrorMessage = 'Enter End Date';
      }
      if (this.journalStartDate && this.journalEndDate && this.journalEndDate < this.journalStartDate) {
        check = true;
        this.journalEndDateErrorMessage = 'End Date > Start Date';
      }
      if (check == true) {
        return;
      }

      await this.getJournalListing();
      this.journalFiltersIsOpen = false;
    },
    async getJournalListing() {
      this.$fullscreenLoading('Getting Journal');
      this.journalListing = [];
      this.selectedJournal = [];
      const postBody = {
        masterfile: 'JOURNAL',
        taxjournal: '0',
        startdate: this.journalStartDate.formatString('yyyy-MM-dd') ?? '',
        enddate: this.journalEndDate.formatString('yyyy-MM-dd') ?? '',
      };
      this.journalListing = await this.$apiCallV2('/FINGLJournal/GetFINGLList', postBody);
      this.$fullscreenLoading('');
    },
    async previewClick() {
      if (this.selectedJournal.length == 0) {
        this.$showAlert('error', 'No Journal Selected', 'Please select at least one journal to preview');
        return;
      }
      this.previewButtonDisabled = true;

      let allDocumentType = '';
      if (this.selectedDocumentType.length == 0) {
        allDocumentType = this.documentTypeList.map((m) => m['keyValue']).join(',');
      } else {
        allDocumentType = this.selectedDocumentType.map((m) => m['keyValue']).join(',');
      }

      this.$fullscreenLoading('Getting Journal Data');
      const jsonBody = {
        batchnoarray: this.selectedJournal.map((m) => m['Batch No']).join(','),
        // txnstartdate: this.allTransaction ? '' : this.txnStartDate.formatString('yyyy-MM-dd'),
        // txnenddate: this.allTransaction ? '' : this.txnEndDate.formatString('yyyy-MM-dd'),
        txnstartdate: '', //set to empty so that return all txn of the batch no
        txnenddate: '', //set to empty so that return all txn of the batch no
        doctypeselection: allDocumentType,
        exclcancelrec: this.exclCancelRec ? '1' : '0',
        exclpostrec: this.exclPostRec ? '1' : '0',
        reportformat: this.selectedReportFormat['key'],
      };

      const result = await this.$apiCallV2('/FINGLJournal/PrintFINGLJournalListing', jsonBody);
      const formattedJournalDetails = [];
      const templateFileNames = [];
      if (this.selectedReportFormat['key'] == 'SUMMARY') {
        templateFileNames.push('FINGLJournalSummary.json');
        this.downloadFileName = `FINGL_JournalSummary_${new Date().formatString('yyyyMMddHHmm')}`;
        let totalNoOfEntry = 0;
        let totalDebit = 0;
        let totalCredit = 0;
        const batch = result['Batch Listing']['Batch'];
        if (batch && batch.length > 0) {
          totalNoOfEntry = batch.map((m) => Number(m['noofentry'])).reduce((a, b) => a + b, 0);
          totalDebit = batch.map((m) => Number(m['totaldebit'])).reduce((a, b) => a + b, 0);
          totalCredit = batch.map((m) => Number(m['totalcredit'])).reduce((a, b) => a + b, 0);
        }

        formattedJournalDetails.push({
          totalnoofentry: totalNoOfEntry,
          totaldebit: this.$currencyFormat(totalDebit),
          totalcredit: this.$currencyFormat(totalCredit),
          batchList: batch.map((m) => {
            return {
              date: m['sysdate'] ? new Date(m['sysdate']).formatString('MM/yyyy') : '',
              batchno: m['batchno'],
              batchname: m['batchname'],
              debitamount: this.$currencyFormat(m['totaldebit']),
              creditamount: this.$currencyFormat(m['totalcredit']),
              noofentry: m['noofentry'],
            };
          }),
        });
      } else {
        this.downloadFileName = `FINGL_JournalDetail_${new Date().formatString('yyyyMMddHHmm')}`;
        const batch = result['Batch Listing']['Batch'];
        if (batch && batch.length > 0) {
          batch.forEach((b) => {
            templateFileNames.push('FINGLJournalDetail.json');
            const totalDebit = b['totaldebit'];
            const totalCredit = b['totalcredit'];
            const formattedTransaction = [];
            if (b['Transaction'] && b['Transaction'].length > 0) {
              const transaction = b['Transaction'];
              let txnRef = 1;
              const ignoreDist = [];
              // transaction.foreach(t => {
              for (const t of transaction) {
                if (ignoreDist.includes(t['distid'])) {
                  continue;
                }
                const dbcr = [];
                if (t['distid'] == '0') {
                  dbcr.push(
                    {
                      accno: t['debitac'],
                      accdesc: t['draccdescr'],
                      remarks: t['strremarks'],
                      dramount: t['txnamount'],
                      cramount: '',
                    },
                    {
                      accno: t['creditac'],
                      accdesc: t['craccdescr'],
                      remarks: t['strremarks'],
                      dramount: '',
                      cramount: t['txnamount'],
                    },
                  );
                } else {
                  //get from transaction array
                  ignoreDist.push(t['distid']);
                  const distTransaction = transaction.filter((f) => f['distid'] == t['distid']);
                  distTransaction.forEach((dt) => {
                    dbcr.push({
                      accno: dt['debitac'] != '0' ? dt['debitac'] : dt['creditac'],
                      accdescr: dt['debitac'] != '0' ? dt['draccdescr'] : dt['craccdescr'],
                      remarks: dt['strremarks'],
                      dramount: dt['debitac'] != '0' ? this.$currencyFormat(dt['txnamount']) : '',
                      cramount: dt['creditac'] != '0' ? this.$currencyFormat(dt['txnamount']) : '',
                    });
                  });
                }

                formattedTransaction.push({
                  txn: txnRef,
                  date:
                    t['txndate'] ? new Date(t['txndate']).formatString(this.$store.state['preferredDateFormat']) : '',
                  party: t['party'] ?? '',
                  partyname: t['partyname'] ?? '',
                  terms: t['terms'] ?? '',
                  duedate:
                    t['duedate'] ? new Date(t['duedate']).formatString(this.$store.state['preferredDateFormat']) : '',
                  chqjob: t['chqjob'] ?? '',
                  receipt: t['receipt'] ?? '',
                  dbcr: dbcr,
                });

                txnRef++;
              }
            }

            formattedJournalDetails.push({
              totaldebit: this.$currencyFormat(totalDebit),
              totalcredit: this.$currencyFormat(totalCredit),
              batchno: b['batchno'],
              batchname: b['batchname'],
              transaction: formattedTransaction,
              _downloadFileName: `${b['batchno']}_${new Date().formatString('yyyyMMddHHmm')}`,
            });
          });
        }
      }

      this.designerV3ReportFiles = templateFileNames;
      this.designerV3ReportData = formattedJournalDetails;
      this.designerV3SharedData = {
        printDate: new Date().formatString(this.$store.state['preferredDateFormat']),
        printTime: new Date().formatString('HH:mm:ss'),
        _companyName: this.rptHeader,
      };

      this.$fullscreenLoading('');
      this.showDesignerV3 = true;
      this.$nextTick(() => {
        this.previewButtonDisabled = false;
      });
    },
  },
  async mounted() {
    this.selectedReportFormat = this.reportFormatOptions[0];

    const result = await this.$apiCallV2('/FINGLJournal/GetFINGLList', { masterfile: 'FINGLRPTHEADER' });
    this.rptHeader = result[0]['headername'];

    await this.filterRefreshClick();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.print-fingljournal-main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;

  > .fingljournal-filter {
    margin-right: 2.5px;
    display: flex;
    flex-direction: column;
    background-color: white;
    padding: 5px;
    width: 50%;

    > .fingljournal-filters-tablebox {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin-bottom: 5px;

      .button-filter-content-container {
        > .refresh-button-container {
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }

    > .fingljournal-tablebox-container {
      flex: 1;
      overflow: auto;
    }

    > .fingljournal-document-type {
      margin-top: 5px;
      height: 80px;
    }
  }

  > .fingljournal-preview {
    margin-left: 2.5px;
    flex: 1;
    background-color: white;
    padding: 5px;

    > .user-instructions {
      height: 100%;
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
      font-size: 20px;
    }
  }
}
</style>
